import React from 'react';
import { User as UserIcon, Trash2 } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { useToast } from '../ui/Toast';
import { ZodiacTheme } from './zodiacThemes';
import { User } from '../../types';
interface SettingsTabProps {
  theme: ZodiacTheme;
  user: User | null;
}
export function SettingsTab({
  theme,
  user
}: SettingsTabProps) {
  const {
    success
  } = useToast();
  return <div className="space-y-8 max-w-3xl" data-id="element-16227">
      <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-16228">
        Настройки аккаунта
      </h2>
      <Card padding="lg" data-id="element-16229">
        <div className="flex items-center gap-3 mb-6" data-id="element-16230">
          <UserIcon className={`w-5 h-5 ${theme.text}`} data-id="element-16231" />
          <h3 className="text-xl font-bold text-slate-900" data-id="element-16232">Личные данные</h3>
        </div>
        <div className="space-y-4" data-id="element-16233">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-16234">
            <Input label="Имя" defaultValue={user?.name?.split(' ')[0] || ''} data-id="element-16235" />
            <Input label="Фамилия" defaultValue={user?.name?.split(' ').slice(1).join(' ') || ''} data-id="element-16236" />
          </div>
          <Input label="Email" type="email" defaultValue={user?.email || ''} data-id="element-16237" />
          <Input label="Телефон" type="tel" defaultValue="" placeholder="+7 (___) ___-__-__" data-id="element-16238" />
        </div>
      </Card>
      <div className="flex justify-between items-center pt-4" data-id="element-16239">
        <button className="text-rose-500 hover:text-rose-600 text-sm font-medium flex items-center transition-colors" data-id="element-16240">
          <Trash2 className="w-4 h-4 mr-2" data-id="element-16241" /> Удалить аккаунт
        </button>
        <Button variant="primary" size="lg" onClick={() => success('Настройки сохранены')} data-id="element-16242">
          Сохранить изменения
        </Button>
      </div>
    </div>;
}